var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92188 0.625V1.98438V4.25H17.0781V1.98438V0.625H19.7969V1.98438V4.25H25.6875V8.78125V11.5V26.9062V29.625H22.9688H3.03125H0.3125V26.9062V11.5V8.78125V4.25H6.20312V1.98438V0.625H8.92188ZM22.9688 11.5H3.03125V26.9062H22.9688V11.5ZM13 15.125V22.375H5.75V15.125H13Z",
    fill: "#0962AD",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDay);
export default __webpack_public_path__ + "static/media/calendar-day.b7e789236998f687643e7ccff679e9d0.svg";
export { ForwardRef as ReactComponent };